import axios from "axios";

const retryUnassignFailJob = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/unassign/${id}/fail-retry`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default retryUnassignFailJob;
